import { Button, Modal } from 'antd';
import React, { useEffect, useState } from 'react';

import { BROWSER_DOWNLOAD_URL, MIN_BROWSER_VERSION } from 'src/config';
import { isBrowserCompatible } from 'src/utils/browser';

const SESSION_STORAGE_KEY = 'browser_check_dismissed';

export const BrowserCheck: React.FC = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    // 检查是否已经在当前会话中关闭过提示
    const isDismissed = sessionStorage.getItem(SESSION_STORAGE_KEY) === 'true';

    // 如果未关闭过且浏览器版本过低，则显示提示
    if (!isDismissed && !isBrowserCompatible(MIN_BROWSER_VERSION)) {
      setIsModalVisible(true);
    }
  }, []);

  // 处理关闭弹窗
  const handleCancel = () => {
    setIsModalVisible(false);
    // 在sessionStorage中记录已关闭，本次会话中不再显示
    sessionStorage.setItem(SESSION_STORAGE_KEY, 'true');
  };

  // 处理升级按钮点击
  const handleUpgrade = () => {
    window.open(BROWSER_DOWNLOAD_URL, '_blank');
    setIsModalVisible(false);
    // 在sessionStorage中记录已关闭，本次会话中不再显示
    sessionStorage.setItem(SESSION_STORAGE_KEY, 'true');
  };

  return (
    <Modal
      title="浏览器版本过低"
      open={isModalVisible}
      onCancel={handleCancel}
      closable={false}
      maskClosable={false}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          关闭
        </Button>,
        <Button key="upgrade" type="primary" onClick={handleUpgrade}>
          现在升级
        </Button>,
      ]}
    >
      <p>您的浏览器已过时，要正常浏览本网站请升级您的浏览器。</p>
    </Modal>
  );
};

export default BrowserCheck;
